import { render, staticRenderFns } from "./CourseWebApplication.vue?vue&type=template&id=5df0e4bf&scoped=true&"
import script from "./CourseWebApplication.vue?vue&type=script&lang=ts&"
export * from "./CourseWebApplication.vue?vue&type=script&lang=ts&"
import style0 from "./CourseWebApplication.vue?vue&type=style&index=0&id=5df0e4bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df0e4bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
